export type FamilyGroupModel = {
  FamilyGroup: string,
  Company: string,
  BusinessUnit: string,
  BusinessUnitDesc: string,
  SuperCategory: string,
  SuperCatDesc: string,
  Category: string,
  CategoryDesc: string,
  Segment: string,
  SegmentDesc: string,
  SubCategory: string,
  SubCategoryDesc: string
}

export const initialValueOfFamilyGroupModel: FamilyGroupModel = {
  FamilyGroup: "",
  Company: "",
  BusinessUnit: "",
  BusinessUnitDesc: "",
  SuperCategory: "",
  SuperCatDesc: "",
  Category: "",
  CategoryDesc: "",
  Segment: "",
  SegmentDesc: "",
  SubCategory: "",
  SubCategoryDesc: ""
}